import { useSelector } from 'react-redux'

import { selectors } from '../../redux'

import { useDeclarationFormLayout } from './useDeclarationFormLayout'
import { useDeclarationFormSteps } from './useDeclarationFormSteps'
import { useDeclarationComplete } from './useDeclarationComplete'
import { useHome } from './useHome'

export const useDeclarationForm = () => {
  const step = useSelector(selectors.declaration.step)
  const user = useSelector(selectors.auth.user)
  const isUpdatingDeclaration = useSelector(selectors.declaration.isUpdatingDeclaration)
  const isInDeclarationProcess = useSelector(selectors.declaration.isInDeclarationProcess)

  const { banner, stepper } = useDeclarationFormLayout()
  const { acceptTerms, steps } = useDeclarationFormSteps()
  const { complete } = useDeclarationComplete()
  const home = useHome()

  return {
    hasDeclaration: !!user?.declaration.id && !isUpdatingDeclaration && !isInDeclarationProcess,
    home,
    hasToOptin: !user?.cgu_accepted_at,
    declarationForm: {
      step,
      background: `${import.meta.env.BASE_URL}images/onboarding/login.jpg`,
      acceptTerms,
      form: {
        formLayout: {
          banner,
          stepper,
        },
        formSteps: steps,
        step,
      },
      complete,
    },
  }
}
